import { getAccessToken } from "../../utils";
import * as actionTypes from "../constants";

export const setLoading = (isLoading) => {
  return {
    type: actionTypes.ACTION_SET_IS_LOADING,
    isLoading,
  };
};

const setToken = (token) => {
  return {
    type: actionTypes.ACTION_SET_TOKEN,
    token,
  };
};

export const setUserError = (error) => {
  return {
    type: actionTypes.ACTION_SET_ERROR,
    error: error,
  };
};

export const getAuthorizationToken = () => {
  return async (dispatch) => {
    dispatch(setLoading(true));
    const accessToken = await getAccessToken();
    if (accessToken) {
      setToken(accessToken);
    } else {
      dispatch(setUserError(true));
    }
    dispatch(setLoading(false));
  };
};
